import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import forms from './forms'

const namespaced = true

const defaultMeta =  {
  current_page: 1,
  desc: false,
  last_page: null,
  order: 'created',
  per_page: null,
  search: null,
  total: null
}

const _defaultView = 'pending'
const _processedView = 'processed'
const _uploadedView = 'uploaded'
const _processedView_User = 'processed_User'

const state = {
  current: null,
  _defaultView,
  _processedView,
  views: {
    [_defaultView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        processed: 'false',
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_processedView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        processed: 'true',
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_uploadedView]: {
      indexByUser: {},
      ids: [],
      fetching: false,
      meta: {
        processed: 'false',
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_processedView_User]: {
      indexByUser: {},
      ids: [],
      fetching: false,
      meta: {
        processed: 'true',
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
  modules: {
    forms
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bioreq/index.js